const FORBIDDEN_TAGS = new Set([
  'SCRIPT',
  'IFRAME',
  'OBJECT',
  'EMBED',
  'FORM',
  'LINK',
  'META',
  'BASE',
]);

const URL_ATTRIBUTES = ['href', 'src', 'xlink:href', 'formaction', 'action'];

function isUnsafeUrl(value) {
  if (!value || typeof value !== 'string') {
    return true;
  }

  return /^\s*(javascript|data|vbscript):/i.test(value.trim());
}

function sanitizeElementAttributes(element) {
  [...element.attributes].forEach((attr) => {
    const name = attr.name.toLowerCase();

    if (name.startsWith('on')) {
      element.removeAttribute(attr.name);
      return;
    }

    if (URL_ATTRIBUTES.includes(name) && isUnsafeUrl(attr.value)) {
      element.removeAttribute(attr.name);
    }
  });
}

function sanitizeNode(node) {
  [...node.children].forEach((child) => {
    if (FORBIDDEN_TAGS.has(child.tagName)) {
      child.remove();
      return;
    }

    sanitizeElementAttributes(child);
    sanitizeNode(child);
  });
}

export function sanitizeHtmlFragment(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }

  const template = document.createElement('template');
  template.innerHTML = html;
  sanitizeNode(template.content);

  return template.innerHTML;
}

export function setInnerHtmlSafely(element, html) {
  if (!element) {
    return;
  }

  element.innerHTML = sanitizeHtmlFragment(html);
}

export function setJQueryHtmlSafely($element, html) {
  if (!$element || !$element.length) {
    return;
  }

  $element.html(sanitizeHtmlFragment(html));
}

export function isSafeHttpUrl(url) {
  if (!url || typeof url !== 'string') {
    return false;
  }

  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch (error) {
    return false;
  }
}

if (typeof window !== 'undefined') {
  window.ihkSanitize = {
    sanitizeHtmlFragment,
    setInnerHtmlSafely,
    setJQueryHtmlSafely,
    isSafeHttpUrl,
  };
}
